export default {"src":"/_next/static/media/icon-pubsAndRestaurants.0e2d94fe.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};